import { getApiUrl, isExternalRoutes } from '../utils/config';

export const API_BASE = getApiUrl();
const externalRoutes = isExternalRoutes();

// Routes to use when running locally to call a local API, bypassing API Gateway
const LOCAL_API_ROUTES = {
  HEALTH: 'health',
  HEALTH_DB: 'health/db',
  PORTFOLIO: 'portfolio',
  GET_USER_LISTS: 'portfolio/user_lists',
  PORTFOLIO_WITH_HISTORY: 'portfolio',
  COMPANY: 'company',
  ARTICLES: 'articles',
  ARTICLE: 'article',
  THEME_ARTICLES: 'articles/theme',
  SEARCH_NOT_IN_PORTFOLIO: 'search',
  SEARCH_INCLUDING_PORTFOLIO: 'search/including_portfolio',
  SEARCH_INCLUDING_PORTFOLIO_USING_ARTICLES: 'search/using_articles',
  START_BULK_SCORE: 'search/bulk',
  GET_BULK_SCORE: 'search/bulk',
  UPLOAD_USER_COMPANY: 'user_company/upload',
  ADD_TO_PORTFOLIO: 'edit-portfolio/add',
  REMOVE_FROM_PORTFOLIO: 'edit-portfolio/remove',
  CREATE_USER_LIST: 'user_lists/create',
  DELETE_USER_LIST: 'user_lists/delete',
  ADD_COMPANY_TO_LIST: 'user_lists/add_company',
  REMOVE_COMPANY_FROM_LIST: 'user_lists/remove_company',
  GET_CONTACT_US_DEFAULTS: 'contact-us',
  POST_CONTACT_US: 'contact-us',
  // DOWNLOAD: 'download',
  CONFIG: 'config',
  VALIDATE_USER: 'admin/validate-user',
  PUT_PRIVACY_CONSENT: 'privacy-consent',
  SEND_TEST_EMAIL: 'mail/test',
  SEND_EMAIL: 'mail/send',
  SAVE_EMAIL_PREFERENCES: 'user/emailPreferences',
  GET_EMAIL_PREFERENCES: 'user/emailPreferences',
  CREATE_CUSTOM_ALERT: 'user/customAlert/create',
  UPDATE_CUSTOM_ALERT: 'user/customAlert/update',
  DELETE_CUSTOM_ALERT: 'user/customAlert/delete',
  UPDATE_USER_EMAIL_PREFERENCES: 'user/updateUserEmailPreferences',
  LOGOUT: 'admin/logout',
  LOGIN: 'admin/login',
  GET_ALL_USERS: 'user/allUsers',
  METRICS: 'metrics',
  LOGIN_STATS: 'metrics/login-attempts',
  PIPELINE_STATUS: 'pipelines/status',
};

// Routes to use in production to call API Gateway
const API_GATEWAY_ROUTES = {
  HEALTH: 'health',
  HEALTH_DB: 'healthDb',
  PORTFOLIO: 'getPortfolio',
  GET_USER_LISTS: 'getUserLists',
  PORTFOLIO_WITH_HISTORY: 'getPortfolioWithHistory',
  COMPANY: 'getCompany',
  ARTICLES: 'getArticles',
  ARTICLE: 'getArticle',
  THEME_ARTICLES: 'getThemeArticles',
  SEARCH_NOT_IN_PORTFOLIO: 'search',
  SEARCH_INCLUDING_PORTFOLIO: 'searchIncludingPortfolio',
  SEARCH_INCLUDING_PORTFOLIO_USING_ARTICLES: 'searchUsingArticles',
  START_BULK_SCORE: 'startScoreInBulk',
  GET_BULK_SCORE: 'getScoreInBulk',
  UPLOAD_USER_COMPANY: 'uploadUserCompany',
  ADD_TO_PORTFOLIO: 'addToPortfolio',
  REMOVE_FROM_PORTFOLIO: 'removeFromPortfolio',
  CREATE_USER_LIST: 'createUserList',
  DELETE_USER_LIST: 'deleteUserList',
  ADD_COMPANY_TO_LIST: 'addCompanyToList',
  REMOVE_COMPANY_FROM_LIST: 'removeCompanyFromList',
  GET_CONTACT_US_DEFAULTS: 'getContactUsDefaults',
  POST_CONTACT_US: 'postContactUs',
  // DOWNLOAD: 'downloadPortfolio',
  CONFIG: 'config',
  VALIDATE_USER: 'validateUser',
  PUT_PRIVACY_CONSENT: 'savePrivacyConsent',
  SEND_TEST_EMAIL: 'testEmail',
  SEND_EMAIL: 'sendEmail',
  SAVE_EMAIL_PREFERENCES: 'user/emailPreferences',
  GET_EMAIL_PREFERENCES: 'user/emailPreferences',
  CREATE_CUSTOM_ALERT: 'createCustomAlert',
  UPDATE_CUSTOM_ALERT: 'updateCustomAlert',
  DELETE_CUSTOM_ALERT: 'deleteCustomAlert',
  UPDATE_USER_EMAIL_PREFERENCES: 'user/updateUserEmailPreferences',
  LOGOUT: 'logout',
  LOGIN: 'login',
  GET_ALL_USERS: 'user/allUsers',
  METRICS: 'getMetrics',
  LOGIN_STATS: 'getLoginAttempts',
  PIPELINE_STATUS: 'getPipelineStatus',
};

export const getThemesPath = (companyId: string): string => {
  return externalRoutes ? `getThemes/${companyId}` : `articles/${companyId}/themes`;
};

export const API_ROUTES = externalRoutes ? API_GATEWAY_ROUTES : LOCAL_API_ROUTES;
